"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfSufficientSettlement = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var PlaceCityTile_1 = require("../../deferredActions/PlaceCityTile");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var SelfSufficientSettlement = (function (_super) {
    __extends(SelfSufficientSettlement, _super);
    function SelfSufficientSettlement() {
        return _super.call(this, {
            name: CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT,
            tags: [Tags_1.Tags.BUILDING, Tags_1.Tags.CITY],
            productionBox: Units_1.Units.of({ megacredits: 2 }),
            metadata: {
                cardNumber: 'P29',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(2); }).city();
                }),
                description: 'Increase your money production 2 steps. Place a City tile.',
            },
        }) || this;
    }
    SelfSufficientSettlement.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.game.defer(new PlaceCityTile_1.PlaceCityTile(player));
        return undefined;
    };
    return SelfSufficientSettlement;
}(PreludeCard_1.PreludeCard));
exports.SelfSufficientSettlement = SelfSufficientSettlement;
